import React from 'react';
import Countdown from 'react-countdown';
import flowers from '../img/flowers1.png';

type CountdownUnitProps = {
  value: number;
  label: string;
};

const CountdownUnit: React.FC<CountdownUnitProps> = ({ value, label }) => (
  <div className="flex flex-col items-center justify-center text-center border border-customPink w-full max-w-32 aspect-square">
    <span className="text-4xl text-[#737373]">{value}</span>
    <span className="text-[#737373] text-[8px] font-normal tracking-[2.9px] uppercase">
      {label}
    </span>
  </div>
);
const WeddingSection: React.FC = () => {
  const weddingDate = new Date('2025-03-15T00:00:00');

  const countdownRenderer = ({ days, hours, minutes, seconds }: any) => (
    <div className="flex items-center justify-center">
      <div className="flex items-center justify-center gap-4 sm:gap-6 md:gap-8 w-full px-4">
        <CountdownUnit value={days} label="Días" />
        <CountdownUnit value={hours} label="Horas" />
        <CountdownUnit value={minutes} label="Min" />
        <CountdownUnit value={seconds} label="Seg" />
      </div>
    </div>
  );

  return (
    <section className="bg-[#FDF7F3] text-center pt-8">
      <h2 className="text-title text-[#B94665] px-2">
        ¡Contando los días para celebrar juntos!
      </h2>

      <div className="mt-12">
        <Countdown date={weddingDate} renderer={countdownRenderer} />
      </div>

      <div className="mt-12">
        <img
          src={flowers}
          alt="Flowers"
          className="mx-auto transform scale-y-[-1] max-h-[7rem]"
        />
      </div>
    </section>
  );
};

export default WeddingSection;
